export default [
    {
        path: '/personalcenter', // 个人中心
        component: resolve => require(['@/pages/vip/personalcenter'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/member', // 会员
        component: resolve => require(['@/pages/vip/member'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/account', // 账户设置
        component: resolve => require(['@/pages/vip/account'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/editinfo', // 编辑信息
        component: resolve => require(['@/pages/vip/editInfo'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/editname', // 修改昵称
        component: resolve => require(['@/pages/vip/editName'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/mailbox', // 绑定邮箱
        component: resolve => require(['@/pages/vip/mailbox'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/idmanage', // 证件管理
        component: resolve => require(['@/pages/vip/idManage'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/addIdCard', // 增加证件
        component: resolve => require(['@/pages/vip/addIdCard'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/psgmanage', // 乘机人管理选择
        component: resolve => require(['@/pages/vip/psgManage'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/psgmanage2', // 乘机人管理2
        component: resolve => require(['@/pages/vip/psgManage2'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/assigneeList', // 受让人管理
        component: resolve => require(['@/pages/vip/assigneeList'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/addAssignee', // 增加/修改/删除受让人
        component: resolve => require(['@/pages/vip/addAssignee'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/saveSuccess', // 保存受让人成功
        component: resolve => require(['@/pages/vip/saveSuccess'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/myIntegral', // 我的积分
        component: resolve => require(['@/pages/vip/myIntegral'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/integralLogin', // 积分登录
        component: resolve => require(['@/pages/vip/integralLogin'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/interDetail', // 积分明细
        component: resolve => require(['@/pages/vip/interDetail'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/interRule', // 积分规则
        component: resolve => require(['@/pages/vip/interRule'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/raiders', // 升级攻略
        component: resolve => require(['@/pages/vip/raiders'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/addInfo', // 补充信息
        component: resolve => require(['@/pages/vip/addInfo'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/addPsg', // 修改或添加乘机人
        component: resolve => require(['@/pages/vip/addPsg'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/vipEquity', // 会员权益
        component: resolve => require(['@/pages/vip/vipEquity'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/assigneeRule', // 受让人规则
        component: resolve => require(['@/pages/vip/assigneeRule'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/serviceHall', // 服务大厅
        component: resolve => require(['@/pages/home/serviceHall'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/jumpdragonpassh5', // 龙腾免密登录
        component: resolve => require(['@/pages/home/jumpDragonpassH5'], resolve),
        meta: { title: "长龙航空", requiresAuth: true }
    },
    {
        path: '/vipCard', // 电子会员卡
        component: resolve => require(['@/pages/vip/vipCard'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/checkVip', // 判断是不是会员
        component: resolve => require(['@/pages/vip/checkVip'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/selectXProduct',
        component: resolve => require(['@/pages/xproduct/selectXProduct'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/verifyBigCus',
        component: resolve => require(['@/pages/vip/verifyBigCust'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/login',
        component: resolve => require(['@/pages/user/login'], resolve),
        meta: { title: "长龙航空" }
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/vip.js